import * as React from "react";

import { useLogAnalytics } from "@v2/hooks/useLogAnalytics";

import { CAMPAIGN_WELCOME_CONTENT } from "./campaignContent";
import { BetaIntroVideo } from "./components/BetaIntroVideo";
import { StepActions } from "./components/StepActions";

// Full-screen first step of /beta/enable pitching Replo Agent before the workspace/project steps.
export const AgentWelcomeScreen: React.FC<{
  source: string | null;
  onOptIn: () => void;
}> = ({ source, onOptIn }) => {
  const logEvent = useLogAnalytics();

  // eslint-disable-next-line replo/no-use-effect -- Fire the viewed event once when the welcome screen mounts.
  React.useEffect(() => {
    logEvent("agent.beta.welcome.viewed", { source });
  }, [logEvent, source]);

  const campaignContent = source ? CAMPAIGN_WELCOME_CONTENT[source] : undefined;

  return (
    <div className="relative flex min-h-screen w-full flex-col items-center bg-surface px-4 py-16">
      <img
        src="/images/onboarding/replo-wordmark-black.svg"
        alt="Replo"
        className="absolute left-5 top-5 h-7 w-auto md:left-8 md:top-7"
      />
      <div className="flex w-full max-w-xl flex-1 flex-col justify-center">
        <div className="flex w-full flex-col gap-6">
          <div className="flex flex-col gap-2">
            <h1 className="font-editorial text-3xl font-bold leading-tight text-default md:text-4xl">
              {campaignContent?.headline ?? "Meet the new Replo"}
            </h1>
            <p className="text-sm leading-5 text-muted">
              {campaignContent?.subtitle ??
                "It doesn't just host your pages. It builds, publishes, and runs your store for you."}
            </p>
          </div>
          {campaignContent ? (
            <img
              src={campaignContent.gifSrc}
              alt={campaignContent.gifAlt}
              className="aspect-video w-full overflow-hidden rounded-xl bg-default object-cover shadow-sm"
            />
          ) : (
            <BetaIntroVideo />
          )}
          <StepActions
            submitLabel="Join the Replo Agent beta"
            isSubmitting={false}
            onSubmit={onOptIn}
          />
        </div>
      </div>
    </div>
  );
};
